import * as actionTypes from './actionTypes';

const initialState = {
  dashboardId: null,
  isLoading: false,
  currentBreakpoint: 'lg',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        dashboardId: action.id,
        isLoading: false,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        dashboardId: action.id,
      };
    case actionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        dashboardId: action.id,
      };
    case actionTypes.SET_CURRENT_BREAKPOINT:
      return {
        ...state,
        currentBreakpoint: action.breakpoint,
      };
    default:
      return state;
  }
};
